import { defineAsyncComponent } from 'vue';
const components = [
  {
    name: 'BevaSelect',
    component: defineAsyncComponent(() => import('./BevaSelect/BevaSelect.vue')),
  },
  {
    name: 'BevaLoading',
    component: defineAsyncComponent(() => import('./BevaLoading/BevaLoading.vue')),
  },
  {
    name: 'BevaBackwardHeader',
    component: defineAsyncComponent(() => import('./BevaBackwardHeader/BevaBackwardHeader.vue')),
  },
  {
    name: 'BevaButton',
    component: defineAsyncComponent(() => import('./BevaButton/BevaButton.vue')),
  },
  {
    name: 'BevaActionButton',
    component: defineAsyncComponent(() => import('./BevaActionButton/BevaActionButton.vue')),
  },
  {
    name: 'BevaTable',
    component: defineAsyncComponent(() => import('./BevaTable/BevaTable.vue')),
  },
  {
    name: 'BevaUpload',
    component: defineAsyncComponent(() => import('./BevaUpload/BevaUpload.vue')),
  },
  {
    name: 'BevaDateTime',
    component: defineAsyncComponent(() => import('./BevaDateTime/BevaDateTime.vue')),
  },
  {
    name: 'BevaAnnouncement',
    component: defineAsyncComponent(() => import('./BevaAnnouncement/BevaAnnouncement.vue')),
  },
  {
    name: 'BevaRadio',
    component: defineAsyncComponent(() => import('./Inputs/BevaRadio.vue')),
  },
];

export default {
  install: (app) => {
    components.forEach((component) => {
      app.component(component.name, component.component);
    });
  },
};
